export const enableElements = (...targets) => {
  targets.forEach(target => target.removeAttribute('disabled'))
}

export const disableElements = (...targets) => {
  targets.forEach(target => target.setAttribute('disabled', true))
}

export const addSpinner = (target) => {
  const text = target.text
  target.innerHTML = "<i class='fa fa-spin fa-spinner'></i>" + text
}

export const removeSpinner = (target) => {
  target.innerHTML = target.text
}
